define.alias("shared/components/shared/publish/switcher/item/info-text", "media/components/shared/publish/switcher/item/info-text");